import type { SampleMealPhoto } from './types';

export function sortSampleMealPhotos(photos: SampleMealPhoto[]): SampleMealPhoto[] {
  return [...photos].sort((a, b) => (a.order ?? 0) - (b.order ?? 0));
}

export function coverPhoto(photos: SampleMealPhoto[]): SampleMealPhoto | null {
  const sorted = sortSampleMealPhotos(photos).filter((p) => !!p.url);
  return sorted[0] ?? null;
}
